import Vue from 'vue'
import consts from '@/consts'
import { createActionHelpers } from 'vuex-loading'
import i18n from '@/translator'

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
})

const initialStates = function () {
  return {
    error: '',
    metrics: Object,
    reproductions: [],
    songRanking: [],
    reproductionsRefresh: 0
  }
}

const mutations = {

  setMetrics (state, value) {
    state.metrics = value
  },
  setReproductions (state, value) {
    state.reproductions = value
    state.reproductionsRefresh++
  },
  setSongRanking (state, value) {
    state.songRanking = value
  }

}

const actions = {

  getMetrics ({ commit, dispatch }, param) {
    startLoading(dispatch, 'dashboard setMetrics')
    return new Promise((resolve, reject) => {
      const condition = '?from=' + param.from + '&to=' + param.to +
        (param.artistId !== null ? '&artistId=' + param.artistId.toString() : '')
      Vue.http.get(consts.API_BASE_URL + '/artist/singletonValues' + condition).then(
        function (res) {
          endLoading(dispatch, 'dashboard setMetrics')
          if (res.body.status === true) {
            commit('setMetrics', res.body.data)
            resolve()
          } else {
            commit('error', { error: true, message: i18n.t('error.store.tracks') })
            reject(new Error(i18n.t('error.store.network')))
          }
        },
        function () {
          endLoading(dispatch, 'dashboard setMetrics')
          commit('error', i18n.t('error.store.network'))
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },
  getReproductions ({ commit, dispatch }, param) {
    startLoading(dispatch, 'dashboard setReproductions')
    return new Promise((resolve, reject) => {
      const condition = '?from=' + param.from + '&to=' + param.to +
        (param.artistId !== null ? '&artistId=' + param.artistId.toString() : '')
      Vue.http.get(consts.API_BASE_URL + '/artist/reproductions' + condition).then(
        function (res) {
          endLoading(dispatch, 'dashboard setReproductions')
          if (res.body.status === true) {
            commit('setReproductions', res.body.data)
            resolve()
          } else {
            commit('error', { error: true, message: i18n.t('error.store.tracks') })
            reject(new Error(i18n.t('error.store.network')))
          }
        },
        function () {
          endLoading(dispatch, 'dashboard setReproductions')
          commit('error', i18n.t('error.store.network'))
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },
  getSongRanking ({ commit, dispatch }, param) {
    startLoading(dispatch, 'dashboard setSongRanking')
    return new Promise((resolve, reject) => {
      const condition = '?from=' + param.from + '&to=' + param.to +
        (param.artistId !== null ? '&artistId=' + param.artistId.toString() : '')
      Vue.http.get(consts.API_BASE_URL + '/artist/reproductionsRankings' + condition).then(
        function (res) {
          endLoading(dispatch, 'dashboard setSongRanking')
          if (res.body.status === true) {
            commit('setSongRanking', res.body.data)
            resolve()
          } else {
            commit('error', { error: true, message: i18n.t('error.store.tracks') })
            reject(new Error(i18n.t('error.store.network')))
          }
        },
        function () {
          endLoading(dispatch, 'dashboard setSongRanking')
          commit('error', i18n.t('error.store.network'))
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  }
}

const getters = {
  error: state => {
    return state.error
  },

  metrics: state => {
    return state.metrics
  },
  reproductions: state => {
    return state.reproductions
  },
  reproductionsRefresh: state => {
    return state.reproductionsRefresh
  },
  songRanking: state => {
    return state.songRanking
  }

}

const dashboard = {
  namespaced: true,
  initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
}

export default dashboard



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js